import { generateClient } from "aws-amplify/api";
import { listPosts } from "../../graphql/queries";
import PostUpload from "../Posts/PostUpload";
import Posts from "../Posts/Posts";
import "./Home.css";
import React, { useEffect, useState } from "react";

const Home: React.FC = () => {
  const [posts, setPosts] = useState<any[]>([]);

  const fetchPosts = async () => {
    try {
      const client = generateClient();
      const response = await client.graphql({
        query: listPosts,
      });

      const items = response.data?.listPosts?.items || [];

      const sortedPosts = items.sort(
        (a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );

      setPosts(sortedPosts);
    } catch (error) {
      console.error("Failed to fetch posts:", error);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return (
    <div className="home-container">
      <PostUpload onPostSuccess={fetchPosts} />
      <Posts posts={posts} />
    </div>
  );
};

export default Home;
